(() => {
  const LinkedProductsSku = window.LinkedProductsSku;

  if (!LinkedProductsSku) {
    return;
  }

  const state = {
    frame: null,
    observer: null
  };

  let linkedProductsVariantChangeUnsubscriber;

  const isProductPage = () => location.pathname.includes('/products/');

  const getProductRoot = () =>
    document.querySelector('product-info[data-main-product][data-product-id]')
    || document.querySelector('[data-main-product][data-product-id]');

  const getSelectedVariant = productRoot => {
    const selectedVariantNode = productRoot?.querySelector(
      'product-variant-selects [data-selected-variant]'
    );

    if (!selectedVariantNode?.textContent?.trim()) {
      return null;
    }

    try {
      return JSON.parse(selectedVariantNode.textContent);
    } catch (error) {
      return null;
    }
  };

  const renderLinkedProducts = () => {
    if (!isProductPage() || !Array.isArray(window.products)) {
      return;
    }

    const productRoot = getProductRoot();
    const productId = Number(productRoot?.dataset.productId);
    const linkedProductContainer = productRoot?.querySelector('[data-linked-products-sku]');
    const currentColorElem = productRoot?.querySelector('[data-current-color]');

    if (!productRoot || !productId || !linkedProductContainer || !currentColorElem) {
      return;
    }

    const currentProduct = window.products.find(product => product.id === productId);
    const selectedVariant = getSelectedVariant(productRoot);
    const currentSku = selectedVariant?.sku || currentProduct?.sku;
    const activeSku = currentProduct?.sku || selectedVariant?.sku;

    if (!currentProduct || !currentSku) {
      return;
    }

    const linkedProducts = LinkedProductsSku.getLinkedProducts(window.products, currentSku);
    const activeLinked = linkedProducts.find(linked => linked.sku === activeSku);
    const defaultColor = activeLinked
      ? LinkedProductsSku.getColorLabel(activeLinked.title)
      : LinkedProductsSku.getColorLabel(currentProduct.title);

    if (!linkedProducts.length) {
      linkedProductContainer.innerHTML = '';
      currentColorElem.textContent = defaultColor;
      return;
    }

    const markup = linkedProducts.map(linked => {
      const color = LinkedProductsSku.getColorLabel(linked.title);
      return `
        <a href="${linked.url}" class="${linked.sku === activeSku ? 'active' : ''} ${!linked.available ? 'unavailable' : ''}" data-color="${color}">
          <img src="${linked.image}" alt="${linked.title}">
        </a>
      `;
    }).join('');

    if (linkedProductContainer.innerHTML !== markup) {
      linkedProductContainer.innerHTML = markup;
      delete linkedProductContainer.dataset.linkedProductsHoverBound;
    }

    if (linkedProductContainer.dataset.linkedProductsHoverBound !== 'true') {
      linkedProductContainer.addEventListener('mouseover', event => {
        const linkedColorElement = event.target.closest('[data-color]');
        if (!linkedColorElement || !linkedProductContainer.contains(linkedColorElement)) return;
        currentColorElem.textContent = linkedColorElement.dataset.color;
      });

      linkedProductContainer.addEventListener('mouseout', event => {
        const linkedColorElement = event.target.closest('[data-color]');
        if (!linkedColorElement || !linkedProductContainer.contains(linkedColorElement)) return;

        const relatedTarget = event.relatedTarget;
        if (relatedTarget instanceof Node && linkedColorElement.contains(relatedTarget)) {
          return;
        }

        currentColorElem.textContent = defaultColor;
      });

      linkedProductContainer.dataset.linkedProductsHoverBound = 'true';
    }

    currentColorElem.textContent = defaultColor;
  };

  const queueRender = () => LinkedProductsSku.queueRender(state, renderLinkedProducts);

  const initObservers = () => {
    LinkedProductsSku.observeMutations({
      root: document.body,
      state,
      selectors: ['[data-linked-products-sku]', '[data-current-color]', '[data-main-product]', 'product-info'],
      onChange: queueRender
    });
  };

  const init = async () => {
    if (!isProductPage()) {
      return;
    }

    initObservers();

    if (
      !linkedProductsVariantChangeUnsubscriber
      && typeof subscribe === 'function'
      && typeof PUB_SUB_EVENTS !== 'undefined'
      && PUB_SUB_EVENTS.variantChange
    ) {
      linkedProductsVariantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.variantChange,
        queueRender
      );
    }

    document.addEventListener('product-info:loaded', queueRender);
    window.addEventListener('shopify:section:load', queueRender);

    if (!LinkedProductsSku.getStoredProducts()) {
      await LinkedProductsSku.fetchAllProducts();
    } else {
      window.products = LinkedProductsSku.getStoredProducts();
    }

    queueRender();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
